import { SIGN_OUT } from '../actions/authActions/ActionTypes';
import {
  CLEAR_REPORT_PASSWORDS,
  SET_REPORT_PASSWORD,
} from '../actions/reportActions/ActionTypes';
import { Action } from '../models/Action';

export interface ReportState {
  passwords: Record<string, { password: string; timestamp: number }>;
}

const defaultStore: ReportState = {
  passwords: {},
};

export default function ReportReducer(
  state: ReportState = defaultStore,
  action: Action
) {
  switch (action.type) {
    case SET_REPORT_PASSWORD:
      return {
        ...state,
        passwords: {
          ...state.passwords,
          [action.payload.key]: {
            password: action.payload.password,
            timestamp: action.payload.timestamp,
          },
        },
      };
    case CLEAR_REPORT_PASSWORDS:
    case SIGN_OUT:
      return {
        ...state,
        passwords: {},
      };
    default:
      return state;
  }
}
